import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  text: {
    textAlign: 'center',
    fontWeight: 'bold',
  },
});

export default useStyles;
